module.exports = __webpack_public_path__ + "img/fi-rr-wifi-alt.1a145e3b.svg";